"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const developmentConfig = {
    apiKey: 'AIzaSyBeN_nqj3z2ketrhXqvshiO2wQCkpbsFXQ',
    authDomain: 'rafflebox-development.firebaseapp.com',
    projectId: 'rafflebox-development',
    storageBucket: 'rafflebox-development.appspot.com',
    messagingSenderId: '258985147788',
    appId: '1:258985147788:web:928bd34cc81e6df07aaaa9'
};
const testConfig = {
    apiKey: 'AIzaSyC7xohL6oPoIcOWJ6gHGMytNaIc7CyOP4g',
    authDomain: 'rafflebox-test.firebaseapp.com',
    projectId: 'rafflebox-test',
    storageBucket: 'rafflebox-test.appspot.com',
    messagingSenderId: '1011071733066',
    appId: '1:1011071733066:web:0f8cfdb282abd51694c5b3'
};
const productionConfig = {
    apiKey: 'AIzaSyCpE6BjL-kQeygz1OS7gjCHrR77vjGRC4E',
    authDomain: 'rafflebox-prod.firebaseapp.com',
    projectId: 'rafflebox-prod',
    storageBucket: 'rafflebox-prod.appspot.com',
    messagingSenderId: '1031299179338',
    appId: '1:1031299179338:web:104ecf6fa35a76a8b9d7b3'
};
const testPlayerPortalConfig = {
    apiKey: 'AIzaSyALOAjUfTWgSTB63x6FKwSam42OKQF3dKE',
    authDomain: 'rafflebox-test-player-portal.firebaseapp.com',
    projectId: 'rafflebox-test-player-portal',
    storageBucket: 'rafflebox-test-player-portal.appspot.com',
    messagingSenderId: '1045932106897',
    appId: '1:1045932106897:web:df6c15b0ccf2c349778b30'
};
const productionPlayerPortalConfig = {
    apiKey: 'AIzaSyALsZ6KmnG_I7gTG3rh2UBwhlK1npDd0u0',
    authDomain: 'rafflebox-prod-player-portal.firebaseapp.com',
    projectId: 'rafflebox-prod-player-portal',
    storageBucket: 'rafflebox-prod-player-portal.appspot.com',
    messagingSenderId: '620333987381',
    appId: '1:620333987381:web:feefe9b564eaec448b637c'
};
exports.default = {
    development: developmentConfig,
    test: testConfig,
    production: productionConfig,
    testPlayerPortal: testPlayerPortalConfig,
    productionPlayerPortal: productionPlayerPortalConfig
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NvbmZpZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQVNBLE1BQU0saUJBQWlCLEdBQXNCO0lBQzNDLE1BQU0sRUFBRSx5Q0FBeUM7SUFDakQsVUFBVSxFQUFFLHVDQUF1QztJQUNuRCxTQUFTLEVBQUUsdUJBQXVCO0lBQ2xDLGFBQWEsRUFBRSxtQ0FBbUM7SUFDbEQsaUJBQWlCLEVBQUUsY0FBYztJQUNqQyxLQUFLLEVBQUUsMkNBQTJDO0NBQ25ELENBQUM7QUFFRixNQUFNLFVBQVUsR0FBc0I7SUFDcEMsTUFBTSxFQUFFLHlDQUF5QztJQUNqRCxVQUFVLEVBQUUsZ0NBQWdDO0lBQzVDLFNBQVMsRUFBRSxnQkFBZ0I7SUFDM0IsYUFBYSxFQUFFLDRCQUE0QjtJQUMzQyxpQkFBaUIsRUFBRSxlQUFlO0lBQ2xDLEtBQUssRUFBRSw0Q0FBNEM7Q0FDcEQsQ0FBQztBQUVGLE1BQU0sZ0JBQWdCLEdBQXNCO0lBQzFDLE1BQU0sRUFBRSx5Q0FBeUM7SUFDakQsVUFBVSxFQUFFLGdDQUFnQztJQUM1QyxTQUFTLEVBQUUsZ0JBQWdCO0lBQzNCLGFBQWEsRUFBRSw0QkFBNEI7SUFDM0MsaUJBQWlCLEVBQUUsZUFBZTtJQUNsQyxLQUFLLEVBQUUsNENBQTRDO0NBQ3BELENBQUM7QUFFRixNQUFNLHNCQUFzQixHQUFzQjtJQUNoRCxNQUFNLEVBQUUseUNBQXlDO0lBQ2pELFVBQVUsRUFBRSw4Q0FBOEM7SUFDMUQsU0FBUyxFQUFFLDhCQUE4QjtJQUN6QyxhQUFhLEVBQUUsMENBQTBDO0lBQ3pELGlCQUFpQixFQUFFLGVBQWU7SUFDbEMsS0FBSyxFQUFFLDRDQUE0QztDQUNwRCxDQUFDO0FBRUYsTUFBTSw0QkFBNEIsR0FBc0I7SUFDdEQsTUFBTSxFQUFFLHlDQUF5QztJQUNqRCxVQUFVLEVBQUUsOENBQThDO0lBQzFELFNBQVMsRUFBRSw4QkFBOEI7SUFDekMsYUFBYSxFQUFFLDBDQUEwQztJQUN6RCxpQkFBaUIsRUFBRSxjQUFjO0lBQ2pDLEtBQUssRUFBRSwyQ0FBMkM7Q0FDbkQsQ0FBQztBQUVGLGtCQUFlO0lBQ2IsV0FBVyxFQUFFLGlCQUFpQjtJQUM5QixJQUFJLEVBQUUsVUFBVTtJQUNoQixVQUFVLEVBQUUsZ0JBQWdCO0lBQzVCLGdCQUFnQixFQUFFLHNCQUFzQjtJQUN4QyxzQkFBc0IsRUFBRSw0QkFBNEI7Q0FDckQsQ0FBQyJ9